import _, { lastIndexOf } from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, PolicyService, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.data = [];
    var viewModel = {};
    /* 1) In force (Active)
    2) Canceled
    3) Expired
    4) All */

    // This array is used to keep untranslated data used for PC call
    const originalStatus = [
        'In force (Active)', 'Canceled', 'Expired', 'All'
    ];

    $scope.statusList = [$translate.instant('PSA.Web.PSAReport.PolicyPeriodStatus.Active'),
    $translate.instant('PSA.Web.PSAReport.PolicyPeriodStatus.Canceled'),
    $translate.instant('PSA.Web.PSAReport.PolicyPeriodStatus.Expired'),
    $translate.instant('PSA.Web.PSAReport.PolicyPeriodStatus.All')
    ];
    const today = new Date();
    $scope.today = {
        year: today.getFullYear(),
        month: today.getMonth(),
        day: today.getDate()
    };
    ctrl.init = () => {
        if (PSAUSER !== undefined) {
            if (PSAUSER.isDelearLeadOrAudit == undefined || PSAUSER.isDelearLeadOrAudit == false) {
                ModalService.showError('gateway.views.modal.Error', 'gPermission Denied');
                return false;
            }
            else {
                $scope.submissionView = ViewModelService.create(viewModel, 'pc', 'edge.capabilities.quote.submission.dto.ReportDTO');
            }
        }
    };
    ctrl.cancel = function () {
        window.location.hash = "#/PUWReport/"
    };

    ctrl.save = function (form) {
        var firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day);
        var lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day);
        var fDate = moment(firstDate);
        var lDate = moment(lastDate);
        // INCI11159286 - issue with Dates in JUL to SEP
        var MonthsDiff = moment.duration(lDate.diff(fDate)).asMonths();
        var daysDiff = moment.duration(lDate.diff(fDate)).asDays();

        if (MonthsDiff > 3 && (daysDiff > 90 || daysDiff < 0) || MonthsDiff < 0) {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.timeframe');
            return;
        }
        // Using index of translated status to get untranslated index
        const currentStatus = $scope.submissionView.value.policyPeriodStatus;
        const statusIndex = originalStatus[$scope.statusList.indexOf(currentStatus)];
        $scope.submissionView.value.policyPeriodStatus = statusIndex;
        const operation = PolicyService.getPoliciess($scope.submissionView.value);
        operation.then((result) => {
            console.log(result);
            if (result.length > 0) {
                $scope.RRDI = result[0].producerCode
                $scope.data = _.sortBy(result, "registrationDate")
                JSONToCSVConvertor($scope.data, "Policy Report", true, currentStatus); // add policyStatus
            } else {
                // UCWPRODENG-813 - R4 Staging Portal Report dealer KO error message when generate report
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.policy-summary.No results found for this filter');
            }
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.error');
        });
    };

    async function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel, currentStatus) {
        // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

        var CSV = 'sep=,' + '\r\n\n';


        var firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day)
        var lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day)
        var fDate = moment(firstDate)
        var lDate = moment(lastDate)
        // This condition will generate the Label/Header
        var rowTitle = $translate.instant('PSA.Web.PSAReport.CommercialReportTitle') + ",";
        CSV += rowTitle + '\r\n';
        // UCWAR-2138
        var row1 = $translate.instant('PSA.Web.PSAReport.Header.PolicyEffectiveDate') + " : " + $translate.instant('PSA.Web.PSAReport.fromDate') + ': ' + fDate.format('DD/MM/YYYY') + ' ' + $translate.instant('PSA.Web.PSAReport.toDate') + ': ' + lDate.format('DD/MM/YYYY') + ',';
        CSV += row1 + '\r\n';
        if ($scope.submissionView.isGVO.value !== undefined) {
            var row2 = $translate.instant('PSA.Web.PSAReport.IsGVO') + ',';
            CSV += row2 + '\r\n';
        }
        if ($scope.submissionView.isEGVO.value !== undefined) {
            var row2 = $translate.instant('PSA.Web.PSAReport.IsEGVO') + ',';
            CSV += row2 + '\r\n';
        }
        if ($scope.submissionView.policyPeriodStatus.value !== undefined) {
            var row3 = $translate.instant('PSA.Web.PSAReport.Header.Policy-Status') + ' : ' + currentStatus + ',';
            CSV += row3 + '\r\n';
        }
        CSV += '\r\n';

        // Headers
        const headerArray = {
            // "country":"Country",
            "producerCode": $translate.instant('PSA.Web.PSAReport.Header.Producer-Code'),
            "producerName": $translate.instant('PSA.Web.PSAReport.Header.Producer-Name'),
            "organizationName": $translate.instant('PSA.Web.PSAReport.Header.Organization-Name'),
            "postalCode": $translate.instant('PSA.Web.PSAReport.Header.Postal-Code'),
            "policyNumber": $translate.instant('PSA.Web.PSAReport.Header.Policy-Number'),
            "policyStatus": $translate.instant('PSA.Web.PSAReport.Header.Policy-Status'),
            "subscriptionYear": $translate.instant('PSA.Web.PSAReport.Header.Subscription-Year'),
            "policyEffectiveDate": $translate.instant('PSA.Web.PSAReport.PolicyEffectiveDate'),
            "policyExpirationDate": $translate.instant('PSA.Web.PSAReport.Header.Policy-Expiration-Date'),
            "gwofferCode": $translate.instant('PSA.Web.PSAReport.Header.GW-Offer-Code'),
            "duration": $translate.instant('PSA.Web.PSAReport.Header.Duration'),
            "makerWarrantyEndDate": $translate.instant('PSA.Web.PSAReport.Header.Maker-Warranty-End-Date'),
            "grossPremium": $translate.instant('PSA.Web.PSAReport.Header.Gross-Premium'),
            "vin": $translate.instant('PSA.Web.PSAReport.Header.VIN'),
            "brand": $translate.instant('PSA.Web.PSAReport.Header.Brand'),
            "model": $translate.instant('PSA.Web.PSAReport.Header.Model'),
            "licencePlate": $translate.instant('PSA.Web.PSAReport.Header.Licence-Plate'),
            "vehicleType": $translate.instant('PSA.Web.PSAReport.Header.Vehicle-Type'),
            "version": $translate.instant('PSA.Web.PSAReport.Header.Version'),
            "energie": $translate.instant('PSA.Web.PSAReport.Header.Energie'),
            "registrationDate": $translate.instant('PSA.Web.PSAReport.Header.First-Registration-Date'),
            "mileage": $translate.instant('PSA.Web.PSAReport.Header.Mileage'),
            "fourByFour": $translate.instant('PSA.Web.PSAReport.Header.4x4'),
            "carPowerTrain": $translate.instant('PSA.Web.PSAReport.Header.Power-Train'),
            "sellerCode": $translate.instant('PSA.Web.PSAReport.Header.Used-Car-Seller')
        };
        if (ShowLabel) {
            var row = "";

            // This loop will extract the label from 1st index of on array
            for (var key in headerArray) {
                row += headerArray[key] + ',';
                console.log(headerArray[key]);
            }
            // for (var index in arrData[0]) {

            //     //Now convert each value to string and comma-seprated
            //     row += index.toUpperCase() + ',';
            // }
            row = row.slice(0, -1);
            // append Label row with line break
            CSV += row + '\r\n';
        }
        // 1st loop is to extract each row
        for (var i = 0; i < arrData.length; i++) {
            var row = "";
            // 2nd loop will extract each column and convert it in string comma-seprated
            for (key in headerArray) {
                console.log(headerArray[key] + ',');
                if (arrData[i][key] == undefined) {
                    row += '"' + "-" + '",';
                }
                else {
                    // UCWPRODENG-823 format excel
                    if (key == "policyNumber" || key == "model") {
                        //row += '"' +arrData[i][key] + '",';
                        row += "\'" + arrData[i][key] + "\'" + ',';;
                    }
                    else if (key == "grossPremium") {
                        arrData[i][key] = parseFloat(arrData[i][key]).toFixed(2);
                        row += '"' + arrData[i][key] + '",';
                    }
                    else if (key == "fourByFour" && arrData[i][key] == "none") {  // UCWAR-2138
                        row += '"' + $translate.instant('PSA.Web.PSAReport.Field.None') + '",';
                    }
                    else
                        row += '"' + arrData[i][key] + '",';
                }
                // console.log(arrData[i][key]);
            }
            // for (var index in arrData[i]) {
            //     row += '"' + arrData[i][index] + '",';
            // }
            row.slice(0, row.length - 1);
            // add a line break after each row
            CSV += row + '\r\n';
        }
        if (CSV == '') {
            return;
        }
        //Generate a file name
        var fileName = $scope.RRDI + "_Stellantis_Commercial Report_policies_" + moment(new Date()).format('MM/DD/YYYY');
        // "RRDI**_Stellantis_Commercial Report_policies_**CurrentDate*";
        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, "_");
        // Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

        var link = document.createElement("a");
        link.href = uri;
        // set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'PolicyService', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService'];
export default fn;
